import { Clock, ExternalLink, MapPin, Phone } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { content, IMAGES } from "../../data/content";

export const Studios = ({ t }) => (
  <section id="studi" className="bg-[#FAF9F5] py-24 sm:py-32" data-testid="studios-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow>{t.studios.eyebrow}</Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-normal tracking-tight text-[#1E2721] sm:text-4xl lg:text-5xl">
          {t.studios.title}
        </h2>
      </Reveal>

      <Reveal delay={0.1} className="mt-12">
        <div className="overflow-hidden rounded-[1.5rem] shadow-xl shadow-[#4D6354]/10">
          <img
            src={IMAGES.waiting}
            alt="Sala d'attesa e corridoio dello studio"
            data-testid="studios-photo"
            className="aspect-[21/9] w-full object-cover transition-transform duration-700 hover:scale-[1.02]"
            loading="lazy"
          />
        </div>
      </Reveal>

      <div className="mt-10 grid gap-8 lg:grid-cols-2">
        {content.studios.map((s, i) => (
          <Reveal key={s.id} delay={0.08 * i}>
            <article
              data-testid={`studio-card-${s.id}`}
              className="group flex h-full flex-col overflow-hidden rounded-[1.5rem] border border-[#4D6354]/12 bg-[#EFECE6] transition-all duration-500 hover:-translate-y-1 hover:shadow-2xl hover:shadow-[#4D6354]/15"
            >
              <div className="relative h-64 w-full overflow-hidden sm:h-72">
                <iframe
                  title={`Mappa ${s.name}`}
                  data-testid={`studio-map-${s.id}`}
                  src={s.map}
                  className="h-full w-full border-0"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                />
              </div>
              <div className="flex flex-1 flex-col p-7 sm:p-8">
                <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C49A5A]">
                  {s.city}
                </p>
                <h3 className="mt-2 font-display text-2xl text-[#1E2721] sm:text-3xl">{s.name}</h3>
                <p className="mt-3 flex items-start gap-2 text-sm leading-relaxed text-[#4A554D]">
                  <MapPin size={15} className="mt-0.5 shrink-0 text-[#4D6354]" />
                  {s.address}
                </p>
                <p className="mt-2.5 flex items-start gap-2 text-sm leading-relaxed text-[#4A554D]" data-testid={`studio-hours-${s.id}`}>
                  <Clock size={15} className="mt-0.5 shrink-0 text-[#C49A5A]" />
                  <span>
                    <span className="font-semibold text-[#1E2721]">{t.studios.hours}</span>
                    <span className="block text-xs text-[#556B5C]">
                      {s.id === "torino" ? t.studios.hoursTorino : t.studios.hoursCarignano}
                    </span>
                  </span>
                </p>
                <div className="mt-auto flex flex-wrap items-center gap-3 pt-6">
                  <a
                    href={`tel:+39${s.phone}`}
                    data-testid={`studio-call-${s.id}`}
                    className="inline-flex items-center gap-2 rounded-full bg-[#4D6354] px-5 py-2.5 text-sm font-semibold text-[#FAF9F5] transition-all duration-300 hover:bg-[#3E5244] hover:shadow-lg"
                  >
                    <Phone size={14} />
                    {s.phoneLabel}
                  </a>
                  <span className="text-xs text-[#556B5C]">
                    {s.id === "torino" ? t.studios.torinoPhoneLabel : t.studios.carignanoPhoneLabel}
                  </span>
                  <a
                    href={s.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`studio-maps-link-${s.id}`}
                    className="link-underline ml-auto inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.15em] text-[#4D6354]"
                  >
                    {t.studios.openMaps}
                    <ExternalLink size={12} />
                  </a>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
